import { getGanttTaskRange } from '../../../../engine/core/gantt-task-range.js';
import { getNodeDateRange } from "./dates.js";

export function collectTreeEntries(root) {
  const entries = [];
  function walk(node, depth, parentId = null) {
    if (!node) return;
    entries.push({ node, depth, parentId });
    for (const child of node.children || []) {
      walk(child, depth + 1, node.id);
    }
  }
  walk(root, 0);
  return entries;
}

export function collectDatedEntries(root) {
  return collectTreeEntries(root)
    .filter((entry) => entry.node.id !== root.id)
    .map((entry) => {
      const range = getNodeDateRange(entry.node) || getGanttTaskRange(entry.node);
      return range ? { ...entry, ...range } : null;
    })
    .filter(Boolean)
    .sort((a, b) => a.startDay - b.startDay || a.endDay - b.endDay || a.depth - b.depth);
}

export function collectLeafTasks(root) {
  const tasks = [];
  function walk(node, parentName = "") {
    for (const child of node.children || []) {
      if (child.children?.length) {
        walk(child, child.name || parentName);
      } else {
        tasks.push({ ...child, parentName });
      }
    }
  }
  walk(root);
  return tasks;
}
